import * as React from "react";
import classnames from "classnames";

import Modal from "@common/components/Molecules/Modal";
import { JobType, constants } from "common/_constants";

interface RewardDetailsProps {
    isOpen: boolean;
    closeModal: () => void;
    rewardDetails: {
        total_commission_in_us_dollars: string;
        submission_commission_in_us_dollars: string;
        interview_commission_in_us_dollars: string;
        hire_commission_in_us_dollars: string;
        employment_guarantee: string;
        employment_guarantee_payment: string;
        job_type_id: number;
    };
}

export const RewardDetails = (props: RewardDetailsProps) => {
    const { isOpen, closeModal, rewardDetails } = props;

    const paymentDetailsPrefix =
        "Rewards are subject to change at Relode's discretion.";

    const isFullTimeOrPartTime =
        rewardDetails.job_type_id === constants.JobType.FULLTIME ||
        rewardDetails.job_type_id === constants.JobType.PARTTIME;

    let paymentDetailsText: React.ReactNode = null;

    let disclaimerSubtext: React.ReactNode = null;

    let employmentGuaranteeDetails: React.ReactNode = null;

    if (isFullTimeOrPartTime) {
        paymentDetailsText = (
            <>
                <p>
                    The submission and interview rewards are paid out one day
                    after the system status has been updated. The hire reward is
                    paid out as follows:
                </p>
            </>
        );
        employmentGuaranteeDetails = (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <strong>
                    {rewardDetails.employment_guarantee} guarantee <br />
                    {rewardDetails.employment_guarantee_payment} payment
                    installments <br />
                </strong>
            </div>
        );
        disclaimerSubtext = (
            <p>
                * The hire reward amount is estimated based on the job salary.
                The reward paid will be based on actual salary for the hired
                candidate.
            </p>
        );
    } else {
        paymentDetailsText = (
            <>
                <p>
                    The submission and interview rewards are paid out one day
                    after the system status has been updated.
                </p>
            </>
        );
        disclaimerSubtext = (
            <p>
                * The hire reward is estimated based on the number of weeks from
                the contract start date to its end date and is paid based on
                actual hours worked. The reward will be paid proportionally on a
                bi-weekly basis, as soon as Relode receives the approved time
                sheets from the client.
            </p>
        );
    }

    return (
        <Modal
            size="xs"
            isOpen={isOpen}
            closeModal={closeModal}
            title="reward details"
        >
            <div className="c-block">
                <h3 className="c-text--primary">rewards paid at each stage!</h3>
                {!!rewardDetails.submission_commission_in_us_dollars ||
                !!rewardDetails.interview_commission_in_us_dollars ? (
                    <>
                        <div className="c-control__label c-text__gutter-1">
                            consideration stage
                        </div>                        
                        {rewardDetails.submission_commission_in_us_dollars ? (
                            <p className="c-text__margin-strip c-text__gutter-1">
                                <span className="c-text--bold">
                                    {
                                        rewardDetails.submission_commission_in_us_dollars
                                    }
                                </span>{" "}
                                refer a candidate that is submitted.
                            </p>
                        ) : null}
                        {rewardDetails.interview_commission_in_us_dollars ? (
                            <p className="c-text__margin-strip c-text__gutter-3">
                                <span className="c-text--bold">
                                    {
                                        rewardDetails.interview_commission_in_us_dollars
                                    }
                                </span>{" "}
                                refer a candidate that interviews.
                            </p>
                        ) : null}
                    </>
                ) : null}
                <div className="c-control__label c-text__gutter-1">
                    hired stage
                </div>
                <p className="c-text__margin-strip c-text__gutter-3">
                    <span className="c-text--bold">
                        {rewardDetails.hire_commission_in_us_dollars}*
                    </span>{" "}
                    refer a candidate that gets hired.
                </p>
                <div className="c-control__label c-text__gutter-1">
                    total rewards
                </div>                
                <h2 className="c-text__highlight c-text__margin-strip c-text__gutter-3">
                    {rewardDetails.total_commission_in_us_dollars}
                </h2>
                <h3 className="c-text--primary">payment details</h3>
                <p>{paymentDetailsPrefix}</p>
                <div>{paymentDetailsText}</div>

                {employmentGuaranteeDetails}
                <p>{disclaimerSubtext}</p>
            </div>
        </Modal>
    );
};
